import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { applyPolyfills, defineCustomElements } from 'bth-components/loader';

import { AppModule } from './app/app.module';
import { oAuthApplication } from './app/auth/oauth-application';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

function hasOAuthCallbackInHash(): boolean {
  const hash = window.location.hash ?? '';
  return hash.includes('access_token=') || hash.includes('id_token=') || hash.includes('error=');
}

async function bootstrap() {
  if (hasOAuthCallbackInHash()) {
    await oAuthApplication.handleCallback();
    return;
  }

  if (!oAuthApplication.hasActiveSession()) {
    await oAuthApplication.login(true);
    return;
  }

  const polyfills = applyPolyfills().then(() => defineCustomElements(window));
  const bootstrapModule = platformBrowserDynamic().bootstrapModule(AppModule);
  await Promise.all([polyfills, bootstrapModule]);
}

bootstrap().catch(err => console.error(err));
